import { FintechPapiEmployee, FintechPapiJob } from 'src/api/interfaces';

export interface ProfileInfo {
  jobTitle?: string;
  jobLevel?: string;
  city?: string;
  buildingCode?: string;
  badgeColor?: string;
}

/** Maps a PAPI employee response to the ProfileInfo shape used by the profile UI. */
export function mapEmployeeToProfileInfo(employee: FintechPapiEmployee): ProfileInfo {
  return {
    jobTitle: (employee.job as FintechPapiJob)?.businessTitle || employee.basicInfo?.businessTitle,
    jobLevel: employee.job?.jobLevel,
    city: employee.workLocation?.city,
    buildingCode: employee.workLocation?.buildingCode,
    badgeColor: employee.basicInfo?.badgeColor
  };
}
